export default [
  {
    path: "/rmcProtASL",
    component: () => import("@/components/page/RMC/Protein/ASL/query"),
    meta: { title: "ASL主数据" },
  },
  {
    path: "/rmcProtASL/detail",
    component: () => import("@/components/page/RMC/Protein/ASL/detail"),
    meta: { title: "ASL主数据详情" },
  },
  {
    path: "/rmcProtScore",
    component: () => import("@/components/page/RMC/Protein/rmcScore/query"),
    meta: { title: "RMC评分" },
  },
  {
    path: "/rmcProtScore/detail",
    component: () => import("@/components/page/RMC/Protein/rmcScore/detail"),
    meta: { title: "RMC评分详情" },
  },
  {
    path: "/rmcProtPcQty",
    name:"rmcProtPurchase",
    component: () =>
      import("@/components/page/RMC/Protein/rmcPurchaseQty/query"),
    meta: { title: "采购量" },
  },
  {
    path: "/rmcProtPcQty/detail",
    name:"rmcProtPurchaseDetail",
    component: () =>
      import("@/components/page/RMC/Protein/rmcPurchaseQty/detail"),
    meta: { title: "采购量详情" },
  },
  {
    path: "/rmcProtFarm",
    name: "rmcProtFarm",
    component: () => import("@/components/page/RMC/Protein/rmcFarmList/query"),
    meta: { title: "农场清单" },
  },
  {
    path: "/rmcProtFarm/detail",
    name: "rmcProtFarmDetail",
    component: () => import("@/components/page/RMC/Protein/rmcFarmList/detail"),
    meta: { title: "农场清单详情" },
  },
  {
    path: "/rmcProtFarm/auditDetail",
    name: "rmcProtFarmAuditDetail",
    component: () => import("@/components/page/RMC/Protein/rmcFarmList/auditDetail"),
    meta: { title: "农场清单详情维护" },
  },
  {
    path: "/rmcProtFeedPlant",
    name: "rmcProtFeedPlant",
    component: () =>
      import("@/components/page/RMC/Protein/rmcFeedPlantList/query"),
    meta: { title: "饲料厂清单" },
  },
  {
    path: "/rmcProtFeedPlant/detail",
    name: "rmcProtFeedplantDetail",
    component: () =>
      import("@/components/page/RMC/Protein/rmcFeedPlantList/detail"),
    meta: { title: "饲料厂清单详情" },
  },
  {
    path: "/rmcProtFeedPlant/auditDetail",
    name: "rmcProtFeedplantAuditDetail",
    component: () =>
      import("@/components/page/RMC/Protein/rmcFeedPlantList/auditDetail"),
    meta: { title: "饲料厂清单详情维护" },
  },
  {
    path: "/rmcProtAuditor",
    name: "rmcProtAudit",
    component: () =>
      import("@/components/page/RMC/Protein/rmcAuditorList/query"),
    meta: { title: "审核员清单" },
  },
  {
    path: "/rmcProtAuditor/detail",
    name: "rmcProtAuditDetail",
    component: () =>
      import("@/components/page/RMC/Protein/rmcAuditorList/detail"),
    meta: { title: "审核员清单详情" },
  },
  // 药品清单
  {
    path: "/rmcProtMedicine",
    component: () => import("@/components/page/RMC/Protein/rmcDrugList/query"),
    meta: { title: "药品清单" },
  },
  // 药品清单历史页面
  {
    path: "/drugHistory",
    component: () =>
      import("@/components/page/RMC/Protein/rmcDrugList/drugHistory"),
    meta: { title: "药品清单历史" },
  },
  // 药品清单新增详情页面
  {
    path: "/rmcProtMedicine/detail",
    component: () => import("@/components/page/RMC/Protein/rmcDrugList/detail"),
    meta: { title: "药品清单详情" },
  },
  //药品用量
  {
    path: "/rmcProtMedUsage",
    component: () =>
      import("@/components/page/RMC/Protein/rmcDrugDosage/query"),
    meta: { title: "药品用量" },
  },
  {
    path: "/rmcProtMedUsage/detail",
    component: () =>
      import("@/components/page/RMC/Protein/rmcDrugDosage/detail"),
    meta: { title: "药品用量详情" },
  },
  {
    path: "/rmcProt3P",
    component: () => import("@/components/page/RMC/Protein/Prot3p/query"),
    meta: { title: "ASL审核报告" },
  },
  {
    path: "/rmcProt3P/detail",
    component: () => import("@/components/page/RMC/Protein/Prot3p/detail"),
    meta: { title: "ASL审核报告详情" },
  },
];
